import React, {Component} from "react"
import PropTypes from "prop-types"
import {Button} from "semantic-ui-react"
import SignaturePad from "signature_pad"
import {withTranslation, Trans} from "react-i18next";

let signaturePad
//
// function scaleCanvas(canvas) {
//
//   const DOMSignatureBody = document.querySelector(".SignatureDialog__body")
//   const ratio = Math.max(window.devicePixelRatio || 1, 1)
//
//   canvas.width = DOMSignatureBody.offsetWidth * ratio
//   canvas.height = DOMSignatureBody.offsetHeight * ratio
//   canvas.getContext("2d").scale(ratio, ratio)
//
//   if (signaturePad) {
//     signaturePad.clear()
//   }
//   return canvas
// }

class Signature extends Component {

  static propTypes = {
    onPublish:      PropTypes.func,
    penColor:       PropTypes.string,
    encoderOptions: PropTypes.oneOf( [
      "image/jpeg",
      "image/png"
    ] ),
    publish:        PropTypes.func,
    disabled:       PropTypes.bool,
    setup:          PropTypes.func,
    options:        PropTypes.object,
  }

  static defaultProps = {
    onComplete: () => {
      console.info( "onComplete::not set" )
    },

    setup:   (signaturePad) => {
      console.info( "setup is not set" )
    },
    options: {
      minWidth:        1,
      maxWidth:        3,
      penColor:        "rgb(10,10,10)",
      encoderOptions:  "image/jpeg",
      backgroundColor: "rgb(255,255,255)",
    }
  }

  publish = () => {
    var dataUrl = signaturePad.toDataURL( this.props.encoderOptions )
    return dataUrl
  }

  isEmpty = () => {
    return signaturePad.isEmpty()
  }

  handleResize = () => {
    if ( signaturePad ) {
      //signaturePad.clear()
    }
  }

  componentDidMount() {
    window.addEventListener( "resize", this.handleResize )
    const canvas = this.refs.canvas
    signaturePad = new SignaturePad( canvas, this.props.options )
    this.props.setup( { signaturePad } )
  }

  componentWillUnmount() {
    window.removeEventListener( "resize", this.handleResize )
    signaturePad.off()
  }

  render() {
    let { onSubmit } = this.props;
    let enter = <Trans i18nKey={"general.enter"}>Absenden</Trans>;

    return (
      <div>
        <canvas ref="canvas" height="160" width="320" style={{
          width:    "320px",
          height:   "160px",
          maxWidth: "100%"
        }}/>
        <br/>
        <div className="overlay-ui baseLine"/>
        <div className="pt2 cf">
          <Button size="tiny" floated="left" icon="trash"  onClick={() => {
            signaturePad.clear()
          }}></Button>

          {onSubmit && <Button onClick={() => {
            let isEmpty = this.isEmpty()
            if ( isEmpty ) return
            onSubmit()
          }} color="green">{enter}</Button>}
        </div>
      </div>
    )
  }
}

export default withTranslation()(Signature)



// WEBPACK FOOTER //
// ./src/pages/components/SignatureDialog/Signature/Signature.js